// breadcrumbConfig.ts
export const breadcrumbMap: Record<string, string> = {
  overview: 'Overview',
  sites: 'Sites',
  carbon: 'Carbon Dashboard',
  'bio-diversity': 'Biodiversity Dashboard',
  environment: 'Climate Dashboard', // Matched to TopNavBar naming
  'carbon-dashboard': 'Carbon Dashboard',
  'carbon-credit': 'Carbon Credits',
  'bio-diversity-dashboard': 'Biodiversity Dashboard',
  'bio-diversity-credit': 'Biodiversity Credits',
  'environment-dashboard': 'Climate Dashboard',
  'climate-dashboard': 'Climate Dashboard',
  'change-password': 'Change Password',
  'profile': 'Profile',
  'update-user': 'Update Profile',
  'interactive-map': 'Interactive Map',
  'add-site': 'Add Site',
  'project': 'Project Overview',
  'landing': 'Landing Page',
  'admin': 'Admin',
  'users': 'User Management',
  'deployments': 'Deployments',
  'devices': 'Devices Management'
};
